import { Link } from 'react-router-dom'
import './HeroCTA.css'

interface HeroCTAProps {
  text?: string
  variant?: 'primary' | 'secondary' | 'accent'
}

function HeroCTA({ text = 'Book a Free Parts + Install Plan Call', variant = 'primary' }: HeroCTAProps) {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Link 
      to="/booking" 
      className={`hero-cta hero-cta-${variant}`}
      onClick={scrollToTop}
    >
      {text}
    </Link>
  )
}

export default HeroCTA
